<ng-container *ngIf="decoupleChild && viewLocation !== 'create-project'">
    <ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand" let-onCheckedChange="onCheckedChange">
        <div class="form-inline row-item d-flex align-items-start" [class.active]="clicked === item">
            <button type="button" class="btn btn-toggle p-0 mr-2 float-left" *ngIf="item.children" (click)="onCollapseExpand();levelExpand($event);"
                [class.collapsed]="item.collapsed" [class.open]="!item.collapsed" [attr.aria-label]="item.text">
            </button>

            <span [class.last-child-node]="!item.children" *ngIf="!item.children"></span>
            <div class="form-check">
                <div class="custom-control custom-checkbox" id="{{'currentDiv'}}-{{item.value}}">
                    <input id="{{'currentNode'}}-{{item.value}}" type="checkbox" class="form-check-input custom-control-input position-absolute"
                        [disabled]="item.value === documentId && disableDocument? true:false" [checked]="item.checked" (click)="removeItem(item);clicked = item"
                        [indeterminate]="item.indeterminate" />
                    <label class="custom-control-label text-wrapped cursor-pointer" for="{{'currentNode'}}-{{item.value}}">{{item.text}}</label>
                </div>
            </div>
        </div>
    </ng-template>
    <ngx-treeview [itemTemplate]="itemTemplate" [config]="config" [items]="items" (selectedChange)="onSelectedChange($event)"
        (filterChange)="onFilterChange($event)" class="tree-custom">
    </ngx-treeview>
</ng-container>


<ng-container *ngIf="decoupleChild && viewLocation === 'create-project'">
    <ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand" let-onCheckedChange="onCheckedChange">
        <div class="form-inline row-item d-flex align-items-start position-relative" [class.active]="clicked === item">
            <button type="button" class="btn btn-icon py-0 px-1 position-absolute select-all-child tooltip right font-1x" [attr.aria-label]="'Select all child node'" data-tooltip="Select all child node" *ngIf="item.children && clicked === item && !item.disabled"
                (click)="selectAllChildren(item);">
                <em class="material-icons-outlined font-4x" aria-hidden="true">checklist</em>
            </button>

            <button type="button" class="btn btn-toggle p-0 mr-2 float-left" *ngIf="item.children" (click)="onCollapseExpand();levelExpand($event);"
                [class.collapsed]="item.collapsed" [class.open]="!item.collapsed" [attr.aria-label]="item.text">
            </button>

            <span [class.last-child-node]="!item.children" *ngIf="!item.children"></span>

            <div class="form-check">
                <div class="custom-control custom-checkbox" id="{{'currentDiv'}}-{{item.value}}" [ngStyle]="{'opacity':item.internalDisabled ? '0.3' : '1' }">
                    <input id="{{'currentNode'}}-{{item.value}}" type="checkbox" class="form-check-input custom-control-input position-absolute"
                        [(ngModel)]="item.checked" (click)="getCurrentItem(item);clicked = item" [indeterminate]="item.indeterminate"
                    />
                    <label class="custom-control-label text-wrapped cursor-pointer" for="" (click)="getCurrentItem(item);clicked = item">{{item.text}}</label>
                </div>
            </div>

        </div>
    </ng-template>
    <ngx-treeview [itemTemplate]="itemTemplate" [config]="config" [items]="items" (selectedChange)="onSelectedChange($event)"
        (filterChange)="onFilterChange($event)" class="tree-custom">
    </ngx-treeview>
</ng-container>

<ngx-treeview *ngIf="!decoupleChild" [config]="config" [items]="items" (selectedChange)="onSelectedChange($event)" (filterChange)="onFilterChange($event)">
